import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { DataView } from 'primereact/dataview';
import Data from '../../../../components/Display/Data';
import MultiLineData from '../../../../components/Display/MultiLineData';
import MultipleDataTag from '../../../../components/Display/MultipleDataTag';
import Section from '../../../../components/Display/Section';
import { getConstant } from '../../../../utils/constants';
import ImageItem from '../../common/image/ImageItem';
import ReviewListItem from './Review/ReviewListItem';

function ProjectDetail({
  project,
  handleUpdateProject,
  handleUpdateImages,
  handleDelete,
  handleCreateReview,
  handleDeleteReview,
  handleUpdateReview
}) {
  const updateProjectActions = [
    {
      onClick: handleUpdateProject,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const updateImagesActions = [
    {
      onClick: handleUpdateImages,
      label: 'Modifier les images',
      icon: 'pi-pencil'
    }
  ];

  const addReviewActions = [
    {
      onClick: handleCreateReview,
      label: 'Ajouter un avis',
      icon: 'pi-plus'
    }
  ];

  const confirmReviewDeletion = (review) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette review ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDeleteReview(review)
    });
  };

  const confirmDeletion = (project) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer ce Projet ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(project)
    });
  };

  const reviewItemTemplate = (review) => {
    return (
      <ReviewListItem
        review={review}
        deleteReview={confirmReviewDeletion}
        updateReview={handleUpdateReview}
      />
    );
  };

  return (
    <div className="h-full w-full flex-col flex gap-5">
      <Section label="Informations Générales" actions={updateProjectActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={project.title} large />
          <Data
            key="type"
            label={'Types'}
            value={project.properties
              .filter((property) => property.type === 'cn_project_type')
              .map((property) => property.label)
              .join(', ')}
            large
          />
          <Data key="year" label={'Année'} value={project.year} />
          <Data key="website_url" label={'Url du site'} value={project.website_url} large />
          <MultipleDataTag
            key="status"
            label={'Statuts'}
            tags={[
              getConstant('collectifnode.inProgress', project.in_progress),
              project.is_highlight && {
                label: 'Projet mis en avant',
                icon: 'star',
                bgColor: 'bg-purple-800'
              }
            ]}
            rounded
          />
        </div>
        <div className="flex flex-wrap gap-5">
          <Data
            key="eco_rating_url"
            label={'Carbon Url'}
            value={project.eco_rating_url}
            disabled={!project.is_highlight}
            large
          />
          <Data
            key="eco_rating"
            label={'Note Carbon'}
            value={`${project.eco_rating ? `${project.eco_rating} %` : ''}`}
            disabled={!project.is_highlight}
          />

          <Data
            key="client_type"
            label={'Type de Client'}
            value={project.client_type}
            disabled={!project.is_highlight}
          />
        </div>
        <div className="flex gap-5">
          <MultipleDataTag
            key="technologies"
            label={'Technologies utilisées'}
            tags={project.properties.filter((property) => property.type === 'cn_technology')}
            disabled={!project.is_highlight}
          />
          <MultipleDataTag
            key="expertises"
            label={'Expertises'}
            tags={project.properties.filter((property) => property.type === 'cn_skill')}
            disabled={!project.is_highlight}
          />
        </div>
        <div className="flex gap-5">
          <MultiLineData key="resume" label={'Résumé'} value={project.resume} large asHtml />
          <MultiLineData
            key="description"
            label={'Description'}
            value={project.description}
            large
            asHtml
          />
        </div>
      </Section>

      <Section label="Image Principale">
        {!project.responsive_main_image ? (
          <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
        ) : (
          <ImageItem
            image={project.responsive_main_image}
            alt={`Photo de ${project.title}`}
            className="h-60 w-fit"
          />
        )}
      </Section>

      <Section label="Avis Client" actions={addReviewActions}>
        <DataView
          value={project.reviews}
          itemTemplate={reviewItemTemplate}
          emptyMessage="Aucune review à afficher"
        />
      </Section>

      {project.is_highlight && (
        <Section label="Autres images" actions={updateImagesActions}>
          <div className={`flex flex-wrap gap-3`}>
            {!project.responsive_images.length ? (
              <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
            ) : (
              project.responsive_images.map((img, index) => (
                <ImageItem
                  key={index}
                  image={img}
                  alt={`Photo de ${project.title} n°${index}`}
                  className="h-60"
                />
              ))
            )}
          </div>
        </Section>
      )}

      <Section label="Autres actions">
        <div>
          <Button
            key={'delete'}
            label={'Supprimer le projet'}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(project)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default ProjectDetail;
